export const ShapePreview = ({diameter = 70, color='black', handleColorClick, selected = false, label = '', code = ''}) => {

    return(
        <div
        style={{
          width: diameter,
          height: diameter,
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          backgroundImage:
            `linear-gradient(90deg, ${color} 1px, transparent 1px),` +
            `linear-gradient(180deg, ${color} 1px, transparent 1px)`,
          backgroundSize: "8px 8px",
          position: "relative",
        }}
        key={code}
        onClick={() => handleColorClick(code)}
        className={`rounded-full cursor-pointer transform transition-all duration-200 ease-out ${
          selected
            ? 'shadow-[0_0_0_3px_#1f2937] scale-105 ring-[3px] ring-inset ring-white'
            : 'shadow-[0_2px_8px_rgba(0,0,0,0.12)] hover:shadow-[0_4px_12px_rgba(0,0,0,0.16)] hover:scale-105'
        }`}
        title={label}
      ></div>
    )
}